import { useCallback } from 'react';
import intl from '@/internationalzation/intl';
import { Message, Icon } from '@docs/kd-d2c-components';
import { eed_web_icon_docs_03_action_fuzhi_line } from '@src/assets/icons';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import copy from 'copy-to-clipboard';
import classNames from 'classnames';
import './code-highlight.less';
interface CodeHighlightProps {
  children: React.ReactNode;
  className?: string;
  [key: string]: any;
}
const CodeHighlight = ({ children, className, ...rest }: CodeHighlightProps) => {
  const match = /language-(\w+)/.exec(className || '');
  const onCopyHandle = useCallback((text: string) => {
    try {
      copy(text || '', {
        format: 'text/plain'
      });
      Message.success({
        duration: 2000,
        message: intl.t('复制成功')
      });
    } catch (err) {
      Message.error({
        duration: 2000,
        message: intl.t('复制失败')
      });
    }
  }, []);
  return match ? (
    <div className="code-wrapper">
      <div className="code-title">
        <span>{match[1]}</span>
        <div className="title-copy" onClick={() => onCopyHandle(children as string)}>
          <Icon size={14} className="icon" icon={eed_web_icon_docs_03_action_fuzhi_line} />
          {intl.t('复制')}
        </div>
      </div>
      <SyntaxHighlighter PreTag="div" children={children} language={match[1]} style={vscDarkPlus} />
    </div>
  ) : (
    <code {...rest} className={classNames(className, 'line-code')}>
      {children}
    </code>
  );
};
export default CodeHighlight;
